import { createFileRoute } from "@tanstack/react-router";
import type { FermentationGroupId } from "@brewbase/db/types";
import { ProtocolBrowser } from "@/features/fermentation-journal/components/planning/protocol-browser";

export const Route = createFileRoute(
  "/fermentations/$group_id/planning/protocol",
)({
  component: ProtocolPage,
});

function ProtocolPage() {
  const { group_id } = Route.useParams();
  const groupId = Number(group_id) as FermentationGroupId;

  return (
    <div className="h-full">
      <ProtocolBrowser groupId={groupId} />
    </div>
  );
}
